import { GAEventName } from 'analytics/ga-event-name.enum';
import { createAnalyticsEvent } from '../create-analytics-event';

export const updateAllShippingAddressEvent = createAnalyticsEvent<{
  subscriptionId: number;
}>(({ subscriptionId }) => ({
  event: GAEventName.CHANGE_SHIPPING_ADDRESS,
  subscriptionId
}));

export const createPaymentMethodEvent = createAnalyticsEvent<{
  isDefault: boolean;
  type: string;
}>(({ isDefault, type }) => ({
  event: GAEventName.CREATE_PAYMENT_METHOD,
  isDefault,
  type
}));

export const createHashedEmailChangeEvent = createAnalyticsEvent<{
  hashedCustomerEmail: string | null;
}>(({ hashedCustomerEmail }) => ({
  event: GAEventName.HASHED_EMAIL_CHANGE,
  hashedCustomerEmail
}));
